import React from 'react';

import { Grid } from '@lp/ds-next';

import LPShopDetailsContent from '../components/LPShopDetailsContent';
import PageTitle from '@/components/layout/PageTitle';

const LPShopDetails = () => (
  <Grid container justifyContent="center" spacing={3}>
    <Grid item mobile={10}>
      <PageTitle title="LP SHOP DETAILS" />
    </Grid>
    <Grid item mobile={10}>
      <LPShopDetailsContent />
    </Grid>
  </Grid>
);

export default LPShopDetails;
